export enum AgentIntroSourceType {
	Website = 'website',
	GoogleMap = 'google_map'
}

export type AgentIntroTrainingSettings = {
	connectorIdn: string;
	clientSecret: string;
	externalId: string;
};

export type TrainingSourceSelectorForm = {
	sourceType: AgentIntroSourceType;
	websiteUrl?: string;
	googleMapUrl?: string;
};

export type TrainingSourceSelectorProps = {
	handleSubmit: (source: string, sourceType: AgentIntroSourceType) => void;
	isPending: boolean;
};
